import { render, staticRenderFns } from "./HeadFeeDetail.vue?vue&type=template&id=a15885ee"
import script from "./HeadFeeDetail.vue?vue&type=script&lang=js"
export * from "./HeadFeeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports